export default __webpack_public_path__ + "static/media/tshirt.fc890d71.gif";